export const INIT_MYCASA_FAKE = 'INIT_MYCASA_FAKE';
export const INIT_MYCASA_FAKE_START = 'INIT_MYCASA_FAKE_START';
export const INIT_MYCASA_FAKE_SUCCESS = 'INIT_MYCASA_FAKE_SUCCESS';
export const INIT_MYCASA_FAKE_ERROR = 'INIT_MYCASA_FAKE_ERROR';

export const FETCH_DATA_MYCASA_FAKE = 'FETCH_DATA_MYCASA_FAKE';
export const FETCH_DATA_MYCASA_FAKE_START = 'FETCH_DATA_MYCASA_FAKE_START';
export const FETCH_DATA_MYCASA_FAKE_SUCCESS = 'FETCH_DATA_MYCASA_FAKE_SUCCESS';
export const FETCH_DATA_MYCASA_FAKE_ERROR = 'FETCH_DATA_MYCASA_FAKE_ERROR';

const fetchFn = (fetch, url, verb, params) => fetch(url, {
  method: verb,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Connection: 'keep-alive',
  },
  body: JSON.stringify(params),
  credentials: 'same-origin',
});

export function initMyCasaFake(params) {
  const url = '/portal-srp/api/v1/mycasafake';
  const verb = 'POST';
  const body = {
    site: params.apireq.site, 
    domain: params.domain, 
    locale: params.locale, 
    apireq: params.apireq, 
    baseUri: params.uri,
  };

  return ({ fetch }) => ({
    type: INIT_MYCASA_FAKE,
    payload: {
      promise: fetchFn(fetch, url, verb, body)
        .then(response => response.json())
        .catch(err => console.error('Error init mycasafake', err)),
    },
  });
}

export function fetchMyCasaFakeData(params) {
  const url = '/portal-srp/api/v1/mycasafake/data';
  const verb = 'POST';
  
  return ({ fetch }) => ({
    type: FETCH_DATA_MYCASA_FAKE,
    payload: {
      promise: fetchFn(fetch, url, verb, params)
        .then(response => response.json())
        .catch(err => console.error('Error init mycasafake', err)),
    },
  });
}
